import { SyncDescriptor } from './descriptors.js';
const _registry = [];
function registerSingleton(id, ctorOrDescriptor, supportsDelayedInstantiation) {
    if (!(ctorOrDescriptor instanceof SyncDescriptor)) {
        ctorOrDescriptor = ( new SyncDescriptor(ctorOrDescriptor, [], Boolean(supportsDelayedInstantiation)));
    }
    _registry.push([id, ctorOrDescriptor]);
}
function getSingletonServiceDescriptors() {
    return _registry;
}
export { getSingletonServiceDescriptors, registerSingleton };
